export default "__VITE_ASSET__CcQSQxi2__"